var render = function render(){var _vm=this,_c=_vm._self._c;return _c('stripe-pricing-table',{attrs:{"pricing-table-id":_vm.pricingTableId,"publishable-key":_vm.publishableKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }